<template>
  <div class="item border-r5 bg-white p-3 mb-lg-0 mb-md-3 mb-3 shadow">
    <div class="item-head">
      <div class="img mr-3">
        <i :class="`${icon}`"></i>
      </div>
      <h1 class="h1-after text-uppercase fwb fs-18">{{ title }}</h1>
    </div>
    <p class="roboto-n fs-12 my-2">
      {{ description }}
    </p>
    <router-link :to="{ name: destiny }" class="btn c-white bg-orange w-100"
      >{{ buttonTitle }}
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    destiny: {
      type: String,
      required: true,
    },
    buttonTitle: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.icon {
  font-size: 52px;
  padding: 4px;
}
@import '../../custom/css/sobre.css';
</style>
